import { yupResolver } from '@hookform/resolvers/yup'
import { LoadingButton } from '@mui/lab'
import { Container, Grid, Stack, TextField, Typography } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'
import { useAppDispatch } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import RichTextEditor from 'components/RichTextEditor'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import axiosClient from 'utils/axiosClient'
import * as yup from 'yup'

interface FormInput {
  date: number
  tag: string
  title: string
  content: string
}
export default function NewsRegister() {
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const schema = yup.object({
    tag: yup.string().required('タグを入力してください。'),
    title: yup.string().required('タイトルを入力してください。'),
    content: yup.string().required('内容を入力してください。'),
  })
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm<FormInput>({
    resolver: yupResolver(schema),
    defaultValues: {
      date: new Date().getTime(),
      content: '<p><br></p>',
    },
  })
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(
      UIAction.setBreadcrumbs([
        {
          text: 'ホーム',
          url: '/',
        },
        {
          text: '新着情報管理',
          url: '/news',
        },
        {
          text: '新規登録',
          url: '/news/register',
        },
      ])
    )
  }, [dispatch])
  const onSubmitForm: SubmitHandler<FormInput> = async (data) => {
    try {
      setLoading(true)
      await axiosClient.post('/api/news/', data)

      enqueueSnackbar('新規作成が完了しました。', {
        variant: 'success',
      })
      navigate('/news')
    } catch (error) {
      enqueueSnackbar('エラーが発生しました。', {
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Grid container spacing={1} mt={2}>
      <Grid item xs={12}>
        <Typography
          variant="h5"
          component="h2"
          fontWeight="bold"
          sx={{ borderBottom: 2 }}
        >
          新規登録
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Container
          disableGutters
          component="form"
          noValidate
          autoComplete="off"
          sx={{
            margin: '0',
            padding: '0 !important',
            mt: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: '0.5rem',
            position: 'relative',
          }}
          onSubmit={handleSubmit(onSubmitForm)}
        >
          <DatePicker
            views={['year', 'month', 'day']}
            label="日付 *"
            inputFormat="yyyy年MM月dd日"
            value={new Date(getValues('date'))}
            onChange={(date) => {
              if (date && date instanceof Date && !isNaN(date.valueOf())) {
                setValue('date', date.getTime(), {
                  shouldValidate: true,
                })
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                size="small"
                fullWidth
                sx={{
                  maxWidth: 380,
                }}
              />
            )}
          />
          <TextField
            required
            autoFocus
            label="タグ"
            margin="dense"
            fullWidth
            size="small"
            variant="outlined"
            {...register('tag')}
            error={'tag' in errors}
            helperText={errors.tag?.message}
          />
          <TextField
            required
            label="タイトル"
            margin="dense"
            fullWidth
            size="small"
            variant="outlined"
            {...register('title')}
            error={'title' in errors}
            helperText={errors.title?.message}
          />

          <Typography>内容</Typography>
          <RichTextEditor
            value={getValues('content')}
            setValue={(val) => setValue('content', val)}
          />

          <Stack mt={4}>
            <LoadingButton
              loading={loading}
              size="small"
              disabled={Object.keys(errors).length > 0}
              color="secondary"
              variant="contained"
              sx={{
                borderRadius: 2,
                width: 200,
                fontWeight: 600,
                fontSize: '1rem',
              }}
              type="submit"
            >
              登録
            </LoadingButton>
          </Stack>
        </Container>
      </Grid>
    </Grid>
  )
}
